@if (isAuthenticated()) {
  <aside class="relative">
    <bx-sidenav-slim
      class="sticky top-0 left-0"
      [logo]="logo()"
      [logoWordmark]="{ logoUrl: 'assets/images/bxInsight_wordmark.svg', alt: 'bxInsight' }"
      [sidenav]="sidenav()"
      [avatar]="avatar"
      [navAccountCard]="accountCard"
      [navAriaLabel]="'navigation.aria.mainNav' | translate"
      [quickNavAriaLabel]="'navigation.aria.quickNav' | translate"
      [footerNavAriaLabel]="'navigation.aria.footerNav' | translate"
      [expandAriaLabel]="'navigation.aria.expandNav' | translate"
      [collapseAriaLabel]="'navigation.aria.collapseNav' | translate"
    >
      <ng-template #avatar>
        @if (userData(); as userData) {
          <avvvatars [value]="userData.email" [size]="40" [style]="'shape'" />
        }
      </ng-template>

      <ng-template #accountCard>
        @if (userData(); as userData) {
          <bx-nav-account-card
            class="border-border-secondary w-[236px] border-t"
            [name]="userData.name"
            [email]="userData.email"
            [logoutAriaLabel]="'navigation.logout' | translate"
            (logoutClick)="logout()"
          ></bx-nav-account-card>
        }
      </ng-template>
    </bx-sidenav-slim>
  </aside>

  <main class="flex-1">
    <router-outlet />
  </main>
}
